/* AFF Super Bundle gift engine.
   Any Murphy cabinet bed in the cart => the 6 free gift SKUs ride along (1 set per order).
   Bed removed => gifts removed. Customer removes a gift => respected for the session
   (re-adding a bed restores the full set). Warehouse-theme events isolated below for
   the future Impact migration. */
(function () {
  'use strict';
  var GIFTS = [
    'premium-cooling-gel-memory-foam-6-mattress-gift',
    '5-year-extended-warranty-gift',
    'premium-white-glove-delivery-service-gift',
    'bamboo-fitted-sheet-set-gift',
    'premium-queen-mattress-protector-gift',
    'premium-cooling-pillows-set-gift'
  ];
  var GIFT_PROP = { 'Included': 'FREE with your cabinet bed' };
  var busy = false, selfChange = false, variantCache = {};

  function isBed(it) {
    return it.product_type !== 'Bundle Gift' && it.price >= 200000 &&
      /cabinet\s*bed|murphy/i.test(it.product_title || it.title || '');
  }
  function isGift(it) { return GIFTS.indexOf(it.handle) > -1; }

  function optOut() { try { return JSON.parse(sessionStorage.getItem('affGiftOptOut') || '{}'); } catch (e) { return {}; } }
  function setOptOut(o) { try { sessionStorage.setItem('affGiftOptOut', JSON.stringify(o)); } catch (e) {} }
  function snapshot() { try { return JSON.parse(sessionStorage.getItem('affGiftSnap') || '{}'); } catch (e) { return {}; } }
  function setSnapshot(o) { try { sessionStorage.setItem('affGiftSnap', JSON.stringify(o)); } catch (e) {} }

  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function variantId(handle) {
    if (variantCache[handle]) return Promise.resolve(variantCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error('gift fetch ' + handle + ' ' + r.status);
      return r.json();
    }).then(function (p) { variantCache[handle] = p.variants[0].id; return variantCache[handle]; });
  }

  function refreshUI() {
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); return Promise.resolve(); }
    return fetch('/cart?section_id=mini-cart').then(function (r) { return r.text(); }).then(function (html) {
      var cur = document.getElementById('mini-cart');
      if (!cur) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.getElementById('mini-cart');
      if (next) {
        var wasOpen = cur.getAttribute('aria-hidden') === 'false';
        cur.parentNode.replaceChild(next, cur);
        if (wasOpen) next.setAttribute('aria-hidden', 'false');
      }
      selfChange = true;
      document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      setTimeout(function () { selfChange = false; }, 50);
    }).catch(function () {});
  }

  function sync(fromUserEvent) {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var beds = cart.items.filter(isBed);
      var gifts = cart.items.filter(isGift);
      var oo = optOut();
      var snap = snapshot();
      var mutated = Promise.resolve();
      var changed = false;

      if (beds.length > 0) {
        // Respect manual removals observed since last sync (unless a fresh bed add reset them)
        if (!fromUserEvent) {
          GIFTS.forEach(function (h) {
            if (snap[h] && !gifts.some(function (g) { return g.handle === h; })) { oo[h] = true; }
          });
          setOptOut(oo);
        }
        var missing = GIFTS.filter(function (h) {
          return !oo[h] && !gifts.some(function (g) { return g.handle === h; });
        });
        if (missing.length) {
          changed = true;
          mutated = Promise.all(missing.map(variantId)).then(function (ids) {
            return fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1, properties: GIFT_PROP }; }) })
            });
          });
        }
        // one gift set per order
        gifts.forEach(function (g) {
          if (g.quantity > 1) {
            changed = true;
            mutated = mutated.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: g.key, quantity: 1 })
              });
            });
          }
        });
      } else if (gifts.length) {
        changed = true;
        gifts.forEach(function (g) {
          mutated = mutated.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: g.key, quantity: 0 })
            });
          });
        });
      }

      return mutated.then(function () {
        var newSnap = {};
        if (beds.length > 0) {
          GIFTS.forEach(function (h) {
            newSnap[h] = !oo[h] || gifts.some(function (g) { return g.handle === h; });
          });
        }
        setSnapshot(newSnap);
        if (changed) return refreshUI();
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* ---- Warehouse-theme event adapter (swap these two hooks for Impact) ---- */
  document.addEventListener('product:added', function () {
    setOptOut({});               // a fresh bed add restores the full bundle
    setTimeout(function () { sync(true); }, 350);
  });
  document.addEventListener('cart:rerendered', function () {
    if (selfChange) return;
    setTimeout(function () { sync(false); }, 250);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(false); });
  } else { sync(false); }
})();
